import { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { Layout } from '../../components/Layout'

export const NotFound: FC = () => {
  return (
    <Layout>
      <Col className="containerBase">
        <Container>
          <Row>
            <StyledWrap>
              <h1>
                <img src="/images/404.svg" alt="404" />
              </h1>
              <h2>お探しのページは見つかりませんでした。</h2>
              <p>入力したアドレスに誤りがある、または、ページが移動した可能性があります。</p>
            </StyledWrap>
          </Row>
        </Container>
      </Col>
    </Layout>
  )
}

const StyledWrap = styled.div`
  text-align: center;
  padding: 0 20px;
  img {
    width: 250px;
  }
  h2 {
    margin-top: 50px;
    margin-bottom: 20px;
  }
`
